const accountMenuDataTest = {
    accountButton: 'account-accountButton',
    menu: {
        serviceAccountButton: 'account-menu-serviceAccount-button',
        trackerButton: 'account-menu-tracker-button'
    },
    cloudShell: {
        cloudShellButtonGlobal: 'cloudShell-button-global',
    },
    serviceAccount: {
        serviceAccountCounter: 'serviceAccount-counter',
        createServiceAccount: 'serviceAccount-createServiceAccount-button',
        createServiceAccountWhenNoServiceAccounts: 'serviceAccount-noExisting-createServiceAccount-button',
    },
    tracker: {
        refresh: 'tracker-refresh-button',
        exportCsv: 'tracker-exportCsv-button',
        counter: 'tracker-counter',
        taskItem: {
            statusIcon: 'tracker-taskItem-statusIcon',
            actionName: 'tracker-taskItem-actionName',
            resourceNameOrId: 'tracker-taskItem-resourceNameOrId',
            serviceName: 'tracker-taskItem-serviceName',
            date: 'tracker-taskItem-date',
            card: 'tracker-taskItem-card',
            cardActive: 'tracker-taskItem-card-active',
        },
        taskDescription: {
            serviceName: 'tracker-taskDescription-serviceName',
            actionName: 'tracker-taskDescription-actionName',
            resourceNameOrId: 'tracker-taskDescription-resourceNameOrId',
            statusIcon: 'tracker-taskDescription-statusIcon',
            statusLabel: 'tracker-taskDescription-statusLabel',
            startTime: 'tracker-taskDescription-startTime',
            user: 'tracker-taskDescription-user',
            proxyResource: 'tracker-taskDescription-proxyResource',
            taskDuration: 'tracker-taskDescription-taskDuration',
            region: 'tracker-taskDescription-region',
            taskId: 'tracker-taskDescription-taskId',
            failureReason: 'tracker-taskDescription-failureReason',
            threeDotsMenuButton: 'tracker-taskItem-threeDotsMenu-button',
            viewApiResponseButton: 'tracker-taskItem-viewApiResponse-button',
            apiResponseCodeSnippet: 'tracker-taskItem-apiResponse-codeSnippet',
        },
        filter: {
            searchForText: 'tracker-filter-searchFor-text',
            timeFrameDropdown: 'tracker-filter-timeFrame-dropdown',
            workloadsDropdown: 'tracker-filter-workloads-dropdown',
            statusesDropdown: 'tracker-filter-statuses-dropdown',
            userDropdown: 'tracker-filter-user-dropdown',
            filterItem: 'tracker-filter-filterItem',
            clearAllButton: 'tracker-filter-clearAll-button',
        }
    }
}

export default accountMenuDataTest
